import * as React from "react";
import Radio from "@mui/material/Radio";
import RadioGroup from "@mui/material/RadioGroup";
import FormControlLabel from "@mui/material/FormControlLabel";
import FormControl from "@mui/material/FormControl";
import FormLabel from "@mui/material/FormLabel";
import { fixedState } from "./DecksState";

export default function DeckRadio({ onChange, value, fixedMap, style }) {
    return (
        <FormControl>
            {/* <FormLabel id="demo-row-radio-buttons-group-label">Gender</FormLabel> */}
            <RadioGroup
                row
                style={style}
                value={value}
                onChange={onChange}
                aria-labelledby="demo-row-radio-buttons-group-label"
                name="row-radio-buttons-group"
            >
                {fixedMap.map((fixedValue) => (
                    <FormControlLabel key={fixedValue} value={fixedValue} control={<Radio />} label={fixedValue} />
                ))}

                {/* <FormControlLabel value="male" control={<Radio />} label="Male" />
        <FormControlLabel value="other" control={<Radio />} label="Other" />
        <FormControlLabel
          value="disabled"
          disabled
          control={<Radio />}
          label="other"
        /> */}
            </RadioGroup>
        </FormControl>
    );
}
